import React from 'react';
import styles from './RadioButton.module.scss';
import { TFunctionResult } from 'i18next';
import classNames from 'classnames';

interface Props {
  label?: string | number | TFunctionResult;
  checked?: boolean;
  onChange?: (e: any) => void;
  disabled?: boolean;
  preventBubbling?: boolean;
  labelClassName?: string;
}

const RadioButton = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  labelClassName,
  preventBubbling = true,
}: Props) => (
  <label
    className={classNames(styles.container, disabled && styles.disabled)}
    onClick={(e: React.MouseEvent<HTMLElement>) =>
      preventBubbling && e.stopPropagation()
    }
  >
    {label && (
      <span
        className={classNames(styles.label, labelClassName && labelClassName)}
      >
        {label}
      </span>
    )}
    <input
      className={styles.input}
      type="radio"
      onChange={onChange && !disabled ? onChange : () => {}}
      checked={checked}
    />
    <span className={styles.radio} />
  </label>
);

export default RadioButton;
